import type { ComponentProps } from 'react'

export function Card({ className = '', ...props }: ComponentProps<'div'>) {
  return <div className={`rounded-2xl shadow-md ${className}`} {...props} />
}
export function CardHeader({ className = '', ...props }: ComponentProps<'div'>) {
  return <div className={`p-4 sm:p-6 pb-0 ${className}`} {...props} />
}
export function CardContent({ className = '', ...props }: ComponentProps<'div'>) {
  return <div className={`p-4 sm:p-6 ${className}`} {...props} />
}

/** Form controls (shared input styles). */
export function FormInput({ className = '', ...props }: ComponentProps<'input'>) {
  return (
    <input 
      className={`border rounded px-3 py-2 w-full focus:border-ds-primaryDark focus:outline-none transition-colors ${className}`}
      {...props}
    />
  )
}

export function FormLabel({ children, className = '', ...props }: ComponentProps<'label'>) {
  return (
    <label 
      className={`text-ds-gray-800 font-medium mb-1 flex items-center ${className}`}
      {...props}
    >
      {children}
    </label>
  )
}

export function FormTextarea({ className = '', ...props }: ComponentProps<'textarea'>) {
  return (
    <textarea 
      className={`border rounded px-3 py-2 w-full focus:border-[var(--ds-primaryDark)] focus:outline-none transition-colors resize-vertical ${className}`}
      {...props}
    />
  )
}

export { Button } from './ui/Button'
export type { ButtonProps, ButtonColor, ButtonSize } from './ui/Button'
export { PercentDonut, clampPercent } from './ui/PercentDonut'
export type { PercentDonutProps } from './ui/PercentDonut'
export { Select } from './ui/Select'
export type { SelectOption, SelectProps } from './ui/Select'
export { TextField } from './ui/TextField'
export type { TextFieldProps } from './ui/TextField'
